// extracted by mini-css-extract-plugin
export default {"menu":"ProfileLayout_menu__N20-b","item":"ProfileLayout_item__f9gwN"};